<template>
  <div class="Component rich-text" v-if="richTextHtml" v-html="richTextHtml"></div>
</template>

<script>
import { renderPrismicContent } from '../helpers/prismicHelpers';

export default {
  name: 'RichText',
  props: {
    sliceData: {
      type: Object,
      required: true
    },
    prismicLang: {
      type: String,
      required: true
    }
  },
  computed: {
    richTextHtml() {
      const content = this.sliceData?.primary?.text;
      if (!content || !Array.isArray(content) || content.length === 0) {
        return '';
      }
      return renderPrismicContent(content);
    }
  }
};
</script>